import { useState, useEffect, useCallback } from "react";
import { useRequest } from "./useRequest";

interface GmailStatus {
  gmailConnected: boolean;
  gmailEmail: string | null;
}

export const useGmailSender = () => {
  const { handleRequest } = useRequest();
  const [gmailStatus, setGmailStatus] = useState<GmailStatus>({
    gmailConnected: false,
    gmailEmail: null,
  });
  const [gmailLoading, setGmailLoading] = useState(false);

  const fetchGmailStatus = useCallback(() => {
    setGmailLoading(true);
    handleRequest({
      endpoint: "gmail/status",
      options: { method: "GET" },
      onSuccess: (res) => {
        setGmailStatus({
          gmailConnected: res.data.gmailConnected,
          gmailEmail: res.data.gmailEmail,
        });
        setGmailLoading(false);
      },
      onError: () => setGmailLoading(false),
    });
  }, []);

  const connectGmail = useCallback(() => {
    setGmailLoading(true);
    const returnTo = encodeURIComponent(window.location.href);
    handleRequest({
      endpoint: `gmail/auth?returnTo=${returnTo}`,
      options: { method: "GET" },
      onSuccess: (res) => {
        if (res.data?.redirectUrl) {
          window.location.replace(res.data.redirectUrl);
        }
        setGmailLoading(false);
      },
      onError: () => setGmailLoading(false),
    });
  }, []);

  const disconnectGmail = useCallback(() => {
    setGmailLoading(true);
    handleRequest({
      endpoint: "gmail/disconnect",
      options: { method: "DELETE" },
      onSuccess: () => {
        setGmailStatus({ gmailConnected: false, gmailEmail: null });
        setGmailLoading(false);
      },
      onError: () => setGmailLoading(false),
    });
  }, []);

  useEffect(() => {
    fetchGmailStatus();
  }, [fetchGmailStatus]);

  return { gmailStatus, gmailLoading, connectGmail, disconnectGmail, fetchGmailStatus };
};
